import { useQuery } from '@tanstack/react-query';
import dynamic from 'next/dynamic';
import { useEffect } from 'react';

import useCategoriesWithLandings from 'hooks/useCategoriesWithHighlightedLandings';

import { sendEvent } from 'lib/gtag';
import { topbarQueryKeys } from 'lib/queryKeys';

import { useWebView } from 'providers/WebViewProvider';

import { getTopbarAd } from 'services/ads';

import SitemapGroupList from './SitemapGroupList';

import TOPBAR from 'constants/topbar';

const TopbarAd = dynamic(() => import('./TopbarAd'));
const TopbarDesktop = dynamic(() => import('./Desktop'));
const TopbarMobile = dynamic(() => import('./Mobile'));

const Topbar = () => {
  const { isTopbarActive } = useWebView();
  const { categoriesWithHighlightedLandings } = useCategoriesWithLandings();

  const { data: topbarAd } = useQuery({
    queryKey: topbarQueryKeys.bannerAd(),
    queryFn: ({ signal }) => getTopbarAd({ signal }),
    cacheTime: Infinity,
    enabled: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

  useEffect(() => {
    if (isTopbarActive) {
      sendEvent({
        action: 'header__appear',
        category: TOPBAR.GA_EVENT_CATEGORY,
      });
    }
  }, [isTopbarActive]);

  if (!isTopbarActive) {
    return null;
  }

  return (
    <>
      {topbarAd && <TopbarAd {...topbarAd} />}
      <header className="sticky top-0 z-40 mb-18 size-full min-h-16 bg-neutral-high-100 transition-all duration-150 ease-in dark:bg-neutral-low-500 lg:mb-0 [&_*]:font-rubik">
        <TopbarDesktop gaEventCategory={TOPBAR.GA_EVENT_CATEGORY} />
        <TopbarMobile gaEventCategory={TOPBAR.GA_EVENT_CATEGORY} />
      </header>
      {/* This is used for SEO purposes... */}
      <SitemapGroupList categories={categoriesWithHighlightedLandings} />
    </>
  );
};

export default Topbar;
